import {ILoadFromJSONOptions, SurveyModel} from "survey-core";
import surveyTheme from "../../assets/survey-theme.json";

/** Special type of model to use for Allai DCIs */
export class AllaiSurveyModel extends SurveyModel {
	constructor() {
		super();

		this.applyTheme(surveyTheme as any);
		this.applyDefaults();
	}

	override fromJSON(json:any, options?:ILoadFromJSONOptions) {
		super.fromJSON(json, options);
		this.applyDefaults();
	}

	/** Apply the default settings for each survey */
	private applyDefaults() {
		this.showCompletePage = false;
		this.loadingHtml = localizedSpinner['en'];
	}

	/** Set the locale of a survey */
	override set locale(value:string) {
		super.locale = value;
		this.loadingHtml = localizedSpinner[value];
	}

	//NOTE: both the getter and setter have to be overridden for some reason, some weird typescript/angular reason
	override get locale() {
		return super.locale;
	}
}

/** Localized loading screen, probably need to externalize this at some point */
const localizedSpinner:{ [key:string]:string } = {
	es: "<div class='spinner'></div> <h4 class='spinner-text'>Por favor, espere<h4>",
	en: "<div class='spinner'></div> <h4 class='spinner-text'>Please wait<h4>"
};
